import React, { Component } from "react";
import styled from "styled-components";
import { rem } from "polished";
import { partial } from "../../common/utils/partial";

import List from "../../common/components/List";
import { Localize } from "../../../locale/localization";
import Button from "../../../ui/button/Button";
import colors from "../../../utils/colors";
import { media } from "../../../utils/uiSizes";

const StyledList = styled(List)`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  ${media.tablet`
    width: 30%;
    max-width: 300px;
  `} align-items: center;
  text-align: center;
  margin: 2rem 0 3rem;
  color: white;

  h3,
  h4 {
    font-family: FyranSans-SemiBold;
    letter-spacing: 0.013rem;
    color: white;
    margin-bottom: 0.625rem;
  }

  h3 {
    font-family: FyranSans-SemiBold;
    font-size: 1.375rem;
    line-height: 1.5625rem;
  }

  h4 {
    font-family: FyranSans-SemiBold;
    color: ${colors.BRAND_PINK};
  }

  a {
    margin-top: auto;
    button {
      font-family:FyranSans-SemiBold;
      font-size:${rem('16px')};
    }
  }
`;

const StyledFigureWrap = styled.div`
  width: 36%;
  max-width: 108px;
  margin-bottom: 1.5rem;
`;

const StyledFigure = styled.figure`
  width: 100%;

  img {
    width: 100%;
    height: auto;
  }
`;

class SecondaryPrizeItemList extends Component {
  renderPrize = prize => {
    const { _id, image, price, name, type } = prize;

    const { onItemClick } = this.props;

    return (
      <StyledWrapper key={_id}>
        {image && (
          <StyledFigureWrap>
            <StyledFigure>
              <img src={image} alt="" />
            </StyledFigure>
          </StyledFigureWrap>
        )}
        <h4>
          {price} {Localize("score")}
        </h4>
        <h3>{name}</h3>
        <p>{type}</p>
        <a onClick={partial(onItemClick, _id)}>
          <Button>{Localize("prize.details")}</Button>
        </a>
      </StyledWrapper>
    );
  };

  render() {
    const { items } = this.props;
    return <StyledList items={items} renderItem={this.renderPrize} />;
  }
}

export default SecondaryPrizeItemList;



// WEBPACK FOOTER //
// ./src/modules/prize/components/SecondaryPrizeItemList.js